/**
 * Blog article read/visitor counts via CounterAPI (public v1).
 * Counts once per browser session per article.
 */
(function () {
  const NAMESPACE = 'roomwell-uk-blog';
  const API = 'https://api.counterapi.dev/v1';
  const SESSION_KEY = 'rw-blog-views-session';

  function sessionMap() {
    try {
      return JSON.parse(sessionStorage.getItem(SESSION_KEY) || '{}');
    } catch (e) {
      return {};
    }
  }

  function markSeen(id) {
    const map = sessionMap();
    map[id] = 1;
    try {
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(map));
    } catch (e) {}
  }

  function hasSeen(id) {
    return Boolean(sessionMap()[id]);
  }

  function formatCount(n) {
    const num = Number(n) || 0;
    if (num >= 1000000) return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    if (num >= 1000) return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
    return String(num);
  }

  function parseCount(payload) {
    if (payload == null) return 0;
    if (typeof payload === 'number') return payload;
    if (typeof payload.count === 'number') return payload.count;
    if (payload.value != null) return Number(payload.value) || 0;
    if (payload.data && payload.data.value != null) return Number(payload.data.value) || 0;
    if (payload.data && payload.data.count != null) return Number(payload.data.count) || 0;
    return 0;
  }

  async function fetchJson(url) {
    const res = await fetch(url, { method: 'GET', mode: 'cors' });
    if (!res.ok) throw new Error('counter ' + res.status);
    return res.json();
  }

  async function getCount(id) {
    return parseCount(await fetchJson(`${API}/${NAMESPACE}/article-${id}/`));
  }

  async function hitCount(id) {
    return parseCount(await fetchJson(`${API}/${NAMESPACE}/article-${id}/up`));
  }

  function setDisplays(id, count) {
    document.querySelectorAll(`[data-blog-views-count="${id}"]`).forEach((el) => {
      el.textContent = formatCount(count);
      el.setAttribute('data-loaded', 'true');
    });
  }

  async function hydrateList() {
    const nodes = document.querySelectorAll('[data-blog-views-count]');
    const ids = [...new Set([...nodes].map((n) => n.getAttribute('data-blog-views-count')).filter(Boolean))];

    await Promise.all(
      ids.map(async (id) => {
        try {
          const count = await getCount(id);
          setDisplays(id, count);
        } catch (e) {
          setDisplays(id, 0);
        }
      })
    );
  }

  async function trackArticlePage() {
    const root = document.querySelector('[data-blog-article-view]');
    if (!root) return;

    const id = root.getAttribute('data-blog-article-view');
    if (!id) return;

    try {
      let count;
      if (hasSeen(id)) {
        count = await getCount(id);
      } else {
        count = await hitCount(id);
        markSeen(id);
      }
      setDisplays(id, count);
    } catch (e) {
      setDisplays(id, 0);
    }
  }

  function init() {
    trackArticlePage();
    hydrateList();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
